import React from 'react'
import Button from '@material-ui/core/Button'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { useMutation } from '@apollo/react-hooks';
import { examMutations } from '../../graphql/mutations'
import { useHistory } from 'react-router-dom'
import { useSnackbar } from 'notistack'

const CreateCustomExamButton = ({ params }) => {
    const { enqueueSnackbar } = useSnackbar()
    const history = useHistory()
    const [adicionaProvaPersonalizada, {loading}] = useMutation(examMutations.ADD_CUSTOM_EXAM, {
        variables: {
            anos: ((params || {}) || {}).anos,
            instituicoes: (params || {}).instituicoes,
            especialidades: (params || {}).especialidades,
            dificuldades: (params || {}).dificuldades,
            quantidadeDePerguntas: (params || {}).quantidadeDePerguntas,
            perguntasAleatorias: (params || {}).perguntasAleatorias,
            respostasAleatorias: (params || {}).respostasAleatorias,
        },
        onCompleted({ adicionaProvaPersonalizada}) {
            if (!adicionaProvaPersonalizada) {
                enqueueSnackbar('Não foram encontradas questões com os critérios informados.')
            } else {
                history.push(`prova_personalizada/${(adicionaProvaPersonalizada || {})._id}`)
            }
        }
    })

    const createCustomExam = () => {
        adicionaProvaPersonalizada()
    }

    return (
        <Button 
            disabled={loading} 
            variant="contained" 
            onClick={() => createCustomExam()} 
            color="primary" 
            style={{ width: 'auto', fontSize: '16px' }} 
            endIcon={<ArrowForwardIosIcon/>}>Iniciar</Button>
    )
}

export default CreateCustomExamButton